
export default {
    data() {
        return {
            list_data: [],
            list_komponen: [],
            list_ruangan: [],
            rekap: [],
            rekapMatrix: [],
            colsRekap: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'],

            page_first: 1,
            page_last: 0,
            page_limit: 15,
            total_data: 0,
            cari_value: '',

            filter: {
                bulan: new Date().getMonth() + 1,
                tahun: new Date().getFullYear(),
                golongan_darah: '',
                komponen_id: '',
                ruangan_id: ''
            },

            bulanOptions: [
                { label: 'Januari', value: 1 },
                { label: 'Februari', value: 2 },
                { label: 'Maret', value: 3 },
                { label: 'April', value: 4 },
                { label: 'Mei', value: 5 },
                { label: 'Juni', value: 6 },
                { label: 'Juli', value: 7 },
                { label: 'Agustus', value: 8 },
                { label: 'September', value: 9 },
                { label: 'Oktober', value: 10 },
                { label: 'November', value: 11 },
                { label: 'Desember', value: 12 }
            ]
        }
    },

    computed: {
        tahunOptions() {
            const current = new Date().getFullYear();
            const options = [];
            for (let y = current - 3; y <= current + 3; y++) {
                options.push(y);
            }
            return options;
        },

        rekapGroupTotals() {
            const totals = { A: 0, B: 0, O: 0, AB: 0, Total: 0 }
            if (!Array.isArray(this.rekapMatrix)) return totals

            this.rekapMatrix.forEach(row => {
                totals.A += Number(row['A+'] || 0) + Number(row['A-'] || 0)
                totals.B += Number(row['B+'] || 0) + Number(row['B-'] || 0)
                totals.O += Number(row['O+'] || 0) + Number(row['O-'] || 0)
                totals.AB += Number(row['AB+'] || 0) + Number(row['AB-'] || 0)
                totals.Total += Number(row.Total || 0)
            })

            return totals
        }
    },

    methods: {
        getView() {
            const query = new URLSearchParams({
                page: this.page_first,
                limit: this.page_limit,
                cari_value: this.cari_value || '',
                bulan: this.filter.bulan || '',
                tahun: this.filter.tahun || '',
                golongan_darah: this.filter.golongan_darah || '',
                komponen_id: this.filter.komponen_id || '',
                ruangan_id: this.filter.ruangan_id || ''
            }).toString()

            fetch(this.$store.state.url.DARAH_KELUAR + "view?" + query, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.list_data = res_data.data || []
                        this.total_data = res_data.total_data || 0
                        this.page_last = res_data.total_pages || 1
                        if (this.page_first > this.page_last) this.page_first = this.page_last || 1
                    } else {
                        this.$q.notify({ type: 'negative', message: res_data.message || 'Gagal memuat data darah keluar' })
                    }
                })
                .catch(err => {
                    console.error('Error fetching darah keluar:', err)
                    this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat data' })
                })
        },

        getRekap() {
            const query = new URLSearchParams({
                bulan: this.filter.bulan || '',
                tahun: this.filter.tahun || ''
            }).toString()

            fetch(this.$store.state.url.DARAH_KELUAR + "rekap?" + query, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.rekap = res_data.data || []
                        this.buildRekapMatrix()
                    }
                })
                .catch(err => {
                    console.error('Error fetching rekap:', err)
                })
        },

        buildRekapMatrix() {
            const map = {};
            this.rekap.forEach(r => {
                const gol = (r.golongan_darah || '').toString().trim().toUpperCase();
                const rhes = (r.rhesus || '').toString().trim();
                const colKey = `${gol}${rhes}`;
                const komponen = r.nama_komponen || `Komponen ${r.komponen_id}`;

                if (!map[komponen]) {
                    map[komponen] = { Komponen: komponen, Total: 0 };
                    this.colsRekap.forEach(c => { map[komponen][c] = 0; });
                }

                const jumlah = Number(r.total_kantong || 0);
                if (this.colsRekap.includes(colKey)) map[komponen][colKey] += jumlah;
                map[komponen].Total += jumlah;
            });

            this.rekapMatrix = Object.values(map).sort((a, b) => b.Total - a.Total);
        },

        getKomponen() {
            fetch(this.$store.state.url.KOMPONEN + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({})
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_komponen = res_data.data || []
                })
                .catch(err => console.error("Error getKomponen:", err))
        },

        getRuangan() {
            fetch(this.$store.state.url.DARAH_KELUAR + "ruangan-list", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.list_ruangan = res_data.data || []
                    }
                })
                .catch(err => console.error("Error getRuangan:", err))
        },

        getBulanLabel(value) {
            const opt = this.bulanOptions.find(b => b.value === value);
            return opt ? opt.label : '';
        },

        indexing(idx) {
            return ((this.page_first - 1) * this.page_limit) + idx
        },

        formatTanggal(dt) {
            if (!dt) return '-'
            const d = new Date(dt)
            if (isNaN(d)) return dt
            return d.toLocaleString('id-ID', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        formatNumber(n) {
            const v = Number(n)
            return isNaN(v) ? (n ?? '-') : v.toLocaleString('id-ID')
        },

        cari_data() {
            this.page_first = 1
            this.getView()
        },

        applyFilter() {
            this.page_first = 1;
            this.getView();
            this.getRekap();
        },
    },

    mounted() {
        this.getKomponen()
        this.getRuangan()
        this.getView()
        this.getRekap()
    }
}
